import CashAccountBase from './base/CashAccountBase';

/**
 * @class CashAccount
 * @extends CashAccountBase
 */
class CashAccount extends CashAccountBase {

}

export default CashAccount;
